import React from 'react';
import { connect } from 'react-redux';
import { Heading2, Heading3 } from '../../ui/Typography/Heading';
import { updateConfigOnboardingSettings } from '../../../redux/config/slice';
import { OnboardingNavbar } from '../OnboardingNavbar/OnboardingNavbar';
import { OnboardingProgress } from '../OnboardingProgress/OnboardingProgress';
import { OnboardingActions } from '../OnboardingActions/OnboardingActions';
import { selectUpdateConfigLoading } from '../../../redux/config/selectors';
import { ONBOARDING_STEPS } from '../../../consts/consts';
import {
  OnboardingHeaderGroup,
  OnboardingContent,
  OnboardingContentGroup,
  OnboardingContentTitle,
  OnboardingStepWrapper,
  OnboardingContentInfo,
  OnboardingContentGroupText,
  OnboardingApiInfoText,
  OnboardingApiLinksWrapper
} from '../../ui/Layout/OnboardingLayout';

const ONBOARDING_API_CASAVI_URL =
  'https://help.oqio.de/de/articles/13857238-schnittstelle-mit-casavi?utm_source=onboarding&utm_medium=inproduct';
const ONBOARDING_API_AAREON_URL =
  'https://help.oqio.de/de/articles/13867911-schnittstelle-mit-aareon-connect?utm_source=onboarding&utm_medium=inproduct';

export const OnboardingStepApiComponent = ({ updateConfigOnboardingSettings, updateConfigLoading }) => {
  const handleBack = () => {
    updateConfigOnboardingSettings({ step: ONBOARDING_STEPS.DATA_SOURCE_SELECT });
  };

  const handleNext = () => {
    updateConfigOnboardingSettings({ step: ONBOARDING_STEPS.PARTNER_USERS });
  };

  return (
    <>
      <OnboardingNavbar loading={updateConfigLoading} />
      <OnboardingProgress />
      <OnboardingContent>
        <OnboardingStepWrapper>
          <OnboardingHeaderGroup>
            <OnboardingContentTitle>
              <Heading2>Import über eine Schnittstelle</Heading2>
            </OnboardingContentTitle>
            <OnboardingContentInfo>
              <OnboardingContentGroupText>
                oqio ermöglicht die Übertragung von Objektdaten und Versicherungsschäden von ERP-Systemen der
                Immobilienwirtschaft in Ihr Versicherungsportal. Die Einrichtung dieser Schnittstelle erfolgt über den
                jeweiligen ERP-Anbieter. Die Anbindung muss von der Immobilienwirtschaft eigenständig mit diesem
                abgestimmt werden, da oqio die Aktivierung nicht durchführt.
              </OnboardingContentGroupText>
            </OnboardingContentInfo>
          </OnboardingHeaderGroup>

          <OnboardingContentGroup className="step-api">
            <Heading3>casavi & Aareon Connect</Heading3>
            <OnboardingApiInfoText>
              Sind Sie ein Versicherungsvertrieb, wenden Sie sich bitte an Ihren Kunden (Immobilienwirtschaft). <br />
              Sind Sie selbst eine Immobilienwirtschaft, kontaktieren Sie bitte direkt Ihren ERP-Anbieter zur
              Freischaltung der Schnittstelle.
            </OnboardingApiInfoText>
            <OnboardingApiInfoText>
              Im Help Center finden Sie Informationen zu den weiteren Schritten.
            </OnboardingApiInfoText>
            <OnboardingApiLinksWrapper>
              <a href={ONBOARDING_API_CASAVI_URL} target="_blank" rel="noopener noreferrer">
                Schnittstelle zu casavi
              </a>
              <a href={ONBOARDING_API_AAREON_URL} target="_blank" rel="noopener noreferrer">
                Schnittstelle zu Aareon Connect
              </a>
            </OnboardingApiLinksWrapper>
          </OnboardingContentGroup>
        </OnboardingStepWrapper>
        <OnboardingActions onBack={handleBack} onNext={handleNext} loading={updateConfigLoading} />
      </OnboardingContent>
    </>
  );
};

const mapStateToProps = (state) => ({
  updateConfigLoading: selectUpdateConfigLoading(state)
});

const mapDispatchToProps = {
  updateConfigOnboardingSettings
};

export const OnboardingStepApi = connect(mapStateToProps, mapDispatchToProps)(OnboardingStepApiComponent);
